(() => {
 const params = new URLSearchParams(location.search);
 const view = params.get('view') || (location.pathname === '/pages/oeuvres' ? 'oeuvres' : location.pathname === '/' ? 'roscoff' : '');
 document.querySelectorAll('.main-nav a').forEach(a => {
  const targetUrl = new URL(a.href); const target = targetUrl.searchParams.get('view') || (targetUrl.pathname === '/pages/oeuvres' ? 'oeuvres' : targetUrl.pathname === '/' ? 'roscoff' : '');
  const active = target === view || ((view === 'lueur' || view.startsWith('oeuvre-') || location.pathname.startsWith('/products/')) && target === 'oeuvres');
  a.classList.toggle('is-current', active);
  if (active) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
 });
 const preview = params.get('preview_theme_id');
 if (preview) document.querySelectorAll('a[href]').forEach(a => {
  const url = new URL(a.href);
  if (url.origin !== location.origin || a.getAttribute('href').startsWith('#')) return;
  if (!['/', '/search', '/cart'].includes(url.pathname) && !url.pathname.startsWith('/pages/') && !url.pathname.startsWith('/policies/')) return;
  url.searchParams.set('preview_theme_id', preview); a.href=url.pathname+url.search+url.hash;
 });
 if (preview) document.querySelectorAll('form[role="search"]').forEach(form => {
  const input = document.createElement('input');input.type='hidden';input.name='preview_theme_id';input.value=preview;form.append(input);
 });
})();